<template>
    <div v-if="visible" class="notification-detail-overlay" @click.self="$emit('close')">
        <div class="notification-detail-modal">
            <div class="modal-header">
                <h3>알림 상세 #{{ detail && detail.notificationIdx }}</h3>
                <button type="button" class="btn-close" @click="$emit('close')" title="닫기">
                    <i class="fas fa-times"></i>
                </button>
            </div>
            <div v-if="loading" class="modal-body loading"><i class="fas fa-spinner fa-spin"></i> 로딩 중...</div>
            <div v-else-if="error" class="modal-body error">{{ error }}</div>
            <div v-else-if="detail" class="modal-body">
                <div class="detail-section">
                    <div class="detail-row">
                        <span class="detail-label">유형</span>
                        <span class="detail-value">
                            <span>
                                {{ getEventLabel(detail.eventType) }}
                            </span>
                        </span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">제목</span>
                        <span class="detail-value">{{ detail.title || "-" }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">심각도</span>
                        <span class="detail-value">{{ getSeverityLabel(detail.severity) }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">발송일시</span>
                        <span class="detail-value">{{ formatDate(detail.sentDate || detail.regDate) }}</span>
                    </div>
                    <div class="detail-row" v-if="detail.referenceType && detail.referenceIdx">
                        <span class="detail-label">참조</span>
                        <span class="detail-value"> {{ detail.referenceType }} #{{ detail.referenceIdx }} </span>
                    </div>
                </div>
                <div v-if="detail.message" class="detail-section content-section">
                    <h4 class="section-title">내용</h4>
                    <div class="message-content">{{ plainMessage }}</div>
                </div>
                <div class="modal-footer">
                    <button
                        v-if="detail.referenceType === 'workflow' && detail.referenceIdx"
                        type="button"
                        class="btn-secondary"
                        @click="$emit('navigate-workflow', detail.referenceIdx)"
                    >
                        <i class="fas fa-external-link-alt"></i> 워크플로우 보기
                    </button>
                    <button type="button" class="btn-primary" @click="$emit('close')">닫기</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CarbonCodes from "@/submodules/carbon-plugin/codes";

export default {
    name: "NotificationDetailModal",
    props: {
        visible: { type: Boolean, default: false },
        detail: { type: Object, default: null },
        loading: { type: Boolean, default: false },
        error: { type: String, default: "" },
    },
    computed: {
        plainMessage() {
            if (!this.detail?.message) return "";
            const div = document.createElement("div");
            div.innerHTML = this.detail.message;
            return div.textContent || div.innerText || "";
        },
    },
    methods: {
        getEventLabel(eventType) {
            return CarbonCodes.eventType.getLabel(eventType) || "-";
        },
        getSeverityLabel(severity) {
            return CarbonCodes.severity.getLabel(severity) || severity || "-";
        },
        formatDate(val) {
            if (!val) return "-";
            const d = typeof val === "string" ? new Date(val) : val;
            if (isNaN(d.getTime())) return String(val);
            return d.toLocaleString("ko-KR", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
            });
        },
    },
};
</script>

<style scoped>
.notification-detail-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
    padding: 20px;
}

.notification-detail-modal {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
    max-width: 560px;
    width: 100%;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
}

.modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid #e2e8f0;
    background: #f8fafc;
    border-radius: 12px 12px 0 0;
}

.modal-header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #1e293b;
}

.btn-close {
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    color: #64748b;
    border-radius: 6px;
    cursor: pointer;
}

.btn-close:hover {
    background: #e2e8f0;
    color: #1e293b;
}

.modal-body {
    padding: 20px;
    overflow-y: auto;
}

.modal-body.loading,
.modal-body.error {
    text-align: center;
    color: #64748b;
    min-height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.detail-section {
    margin-bottom: 16px;
}

.detail-section:last-of-type {
    margin-bottom: 0;
}

.section-title {
    font-size: 13px;
    font-weight: 600;
    color: #64748b;
    margin: 0 0 8px;
}

.detail-row {
    display: flex;
    padding: 8px 0;
    border-bottom: 1px solid #f1f5f9;
}

.detail-row:last-child {
    border-bottom: none;
}

.detail-label {
    min-width: 90px;
    font-size: 13px;
    color: #64748b;
}

.detail-value {
    font-size: 14px;
    color: #1e293b;
}

.content-section {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #e2e8f0;
}

.message-content {
    font-size: 14px;
    line-height: 1.6;
    color: #334155;
}

.modal-footer {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    padding: 16px 20px;
    border-top: 1px solid #e2e8f0;
    background: #f8fafc;
    border-radius: 0 0 12px 12px;
}

.btn-primary,
.btn-secondary {
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 500;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 6px;
}

.btn-primary {
    background: #52b788;
    color: #ffffff;
    border: none;
}

.btn-primary:hover {
    background: #40916c;
}

.btn-secondary {
    background: #ffffff;
    color: #52b788;
    border: 1px solid #52b788;
}

.btn-secondary:hover {
    background: #f0fdf4;
}
</style>
